import React from 'react'

import { Box, withCitrusTheme } from '@gousto-internal/citrus-react'

import {
  RecipeImage as RecipeImageType,
  RecipeQueryResponse,
} from '@library/api-menu-experience/src/interfaces/recipe'

import { DetailCarousel } from '../Carousel'
import { DetailImage } from '../DetailImage'

type RecipeImageProps = {
  displayType: RecipeQueryResponse['displayType']
  images: RecipeImageType[]
}

const ImageContainer = withCitrusTheme(Box, (theme) => ({
  marginLeft: `-${theme.spacing(4)}px`,
  marginTop: `-${theme.spacing(4)}px`,
  width: `calc(100% + 2*${theme.spacing(4)}px)`,
  [`@media (min-width: ${theme.tokens.breakpoints[0]})`]: {
    marginLeft: `-${theme.spacing(6)}px`,
    marginTop: `-${theme.spacing(6)}px`,
    width: `calc(100% + 2*${theme.spacing(6)}px)`,
  },
}))

export const RecipeImage = ({ displayType, images }: RecipeImageProps) => {
  if (!images || images.length === 0) {
    return null
  }

  const carouselVariant = displayType === 'premium' ? 'dark' : 'light'
  const [firstImage] = images

  return (
    <ImageContainer>
      {images.length > 1 ? (
        <DetailCarousel images={images} variant={carouselVariant} />
      ) : (
        <DetailImage media={firstImage.crops} title={firstImage.title} />
      )}
    </ImageContainer>
  )
}
